import { graphqlOperation } from 'aws-amplify';
import { push } from 'connected-react-router';
import { apiCall } from '../../services/initiation';
import {
  checkApartment2,
  checkDetails2,
  checkIfAllStarted,
  checkMember2,
  checkOthersStatus,
  checkStatus,
} from '../App/actions';
import { setLastActive } from '../App/queries';
import { actions as buttonActions } from '../Button';
import { getters as formGetters, actions as formActions } from '../Form';
import constants from './constants';
import mutations from './mutations';
import queries from './queries';

const URLS = {
  '/bytespart': { next: '/bytespart/2', validation: 'showMember2' },
  '/bytespart/2': { next: '/lagenhet' },
  '/lagenhet': { next: '/lagenhet/2', validation: 'showApartment2' },
  '/lagenhet/2': { next: '/skal-till-bytet' },
  '/skal-till-bytet': { next: '/bytesdetaljer' },
  '/bytesdetaljer': { next: '/ladda-upp/minUc' },
};

function updateCase(index, type) {
  window.debug.log('updateCase with type', type);
  return (dispatch, getState) => {
    const { form } = getState();
    const { propositionID } = getState().app;
    const fields = formGetters.getAllFields(form);
    window.debug.log('updateCase fields to update', fields);
    const query = mutations[type](fields, propositionID, index);

    dispatch(buttonActions.setButtonState('loading'));
    window.debug.log('GraphQL mutation', query);

    apiCall(graphqlOperation(query))
      .then((res) => {
        window.debug.log(`Succesfully putted ${type}`, res);
        dispatch(push(getNextUrl(getState())));
        dispatch({
          type: constants.UPDATE_APPLICATION,
          fieldType: type,
          data: Object.values(res.data)[0],
          index,
        });
        dispatch(buttonActions.setButtonState('disabled'));
        dispatch(formActions.submitForm());
      })
      .catch((err) => {
        dispatch(buttonActions.setButtonState('ready'));
        window.debug.log(err);
      });
  };
}

function fetchCase(id) {
  return (dispatch, getState) => {
    const propositionID = id || getState().app.propositionID;

    dispatch({
      type: 'SET_PROPOSITION_ID',
      propositionID,
    });
    dispatch({ type: constants.FETCHING_APPLICATION });

    apiCall(graphqlOperation(queries.Application(propositionID)))
      .then(({ data: { application } }) => {
        window.debug.log('[CASE]: ', application);
        const currentApplicant = application.applicants.filter(
          (applicant) => applicant.id === propositionID
        );

        dispatch(checkStatus(currentApplicant[0]));
        dispatch(checkMember2(currentApplicant[0]));
        dispatch(checkApartment2(currentApplicant[0]));
        dispatch(checkDetails2(application, currentApplicant[0]));
        dispatch(checkOthersStatus(application.applicants));
        dispatch(checkIfTriangle(application));
        dispatch(checkIfAllStarted(application));

        dispatch({
          type: constants.RECEIVED_APPLICATION,
          application,
          currentApplicant: currentApplicant[0],
        });
      })
      .catch((err) => {
        window.debug.log('[CASE REDUCER ERR]: ', err);
        dispatch(errorFetchCase(err));
      });
  };
}

function errorFetchCase(err) {
  // TODO: Redirect to login if error is "not authenticated"
  let error = err.message;

  if (typeof error !== 'string') {
    error = 'Något gick fel';
  }
  return (dispatch) => {
    dispatch({ type: constants.FETCH_APPLICATION_ERROR, error });
  };
}

function checkIfTriangle(application) {
  return (dispatch) => {
    if (application.applicants.length === 3)
      dispatch({ type: constants.SET_TRIANGLE_SWAP });
  };
}

function startApplicant() {
  window.debug.log('starting applicant');
  return (dispatch, getState) => {
    const { propositionID } = getState().app;
    apiCall(graphqlOperation(mutations.startApplicantMutation(propositionID)))
      .then(() => {
        dispatch(fetchCase());
        dispatch(push('/bytespart'));
      })
      .catch((err) => {
        window.debug.log('[START APPLICANT ERROR] :', err);
      });
  };
}

function inactivateApplication() {
  return (dispatch, getState) => {
    const { id } = getState().application.currentApplicant;

    apiCall(graphqlOperation(mutations.cancelApplication(id)))
      .then((res) => {
        window.debug.log(res);
        dispatch(fetchCase());
        dispatch({ type: 'CLOSE_MENU' });
      })
      .catch((err) => {
        window.debug.log(err);
      });
  };
}

function reactivateApplication() {
  return (dispatch, getState) => {
    const { id } = getState().application.currentApplicant;

    apiCall(graphqlOperation(mutations.reactivateApplication(id)))
      .then((res) => {
        window.debug.log(res);
        dispatch(fetchCase());
      })
      .catch((err) => {
        window.debug.log(err);
      });
  };
}

function removeMember2() {
  return (dispatch, getState) => {
    const { id } = getState().application.currentApplicant;

    apiCall(graphqlOperation(mutations.deleteMember2(id)))
      .then((res) => {
        window.debug.log('Successfully removed', res);
        dispatch(push('/bytespart'));
        dispatch({ type: constants.HIDE_MEMBER_2 });
        dispatch({
          type: constants.UPDATE_APPLICATION,
          fieldType: 'members',
          data: null,
          index: 2,
        });
      })
      .catch((err) => {
        window.debug.log(err);
      });
  };
}

function addMember() {
  return (dispatch, getState) => {
    const { id } = getState().application.currentApplicant;

    const newMemberObject = {
      name: { value: null },
      ssn: { value: null },
      phone: { value: null },
      email: { value: null },
      registeredAddress: { value: null },
      registeredPostalCode: { value: null },
      registeredCity: { value: null },
      onCurrentContract: { value: false },
      hasOtherApartment: { value: false },
      otherApartmentInfo: { value: null },
    };

    apiCall(graphqlOperation(mutations.members(newMemberObject, id, 2)))
      .then((res) => {
        window.debug.log('Successfully added ', res);
        dispatch({ type: constants.SHOW_MEMBER2 });
        dispatch({
          type: constants.UPDATE_APPLICATION,
          fieldType: 'members',
          data: res.data.putMember,
          index: 2,
        });
        dispatch(push('/bytespart/2'));
      })
      .catch((err) => {
        window.debug.log(err);
      });
  };
}

export default {
  updateCase,
  fetchCase,
  startApplicant,
  inactivateApplication,
  reactivateApplication,
  removeMember2,
  addMember,
};

function getNextUrl(state) {
  const currentUrl = state.router.location.pathname;
  const next = URLS[currentUrl];
  if (!next) return '/';
  const { [next.validation]: v } = state.application;
  if (v === undefined || v) return next.next;

  const index = Object.keys(URLS).findIndex((url) => url === currentUrl);
  return Object.values(URLS)[index + 1].next;
}



// WEBPACK FOOTER //
// ./src/features/Application/actions.js